(function () {
  if (window.__xtsProductAccordionInitialized) return;
  window.__xtsProductAccordionInitialized = true;

  const animations = new WeakMap();

  function getDuration() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
    return 250;
  }

  function cleanupItemStyles(item) {
    item.style.height = '';
    item.style.overflow = '';
  }

  function cancelAnimation(item) {
    const animation = animations.get(item);
    if (!animation) return;
    animation.cancel();
    animations.delete(item);
  }

  function animateItem(item, startHeight, endHeight, onFinish) {
    const duration = getDuration();

    cancelAnimation(item);
    item.style.height = startHeight;
    item.style.overflow = 'hidden';

    if (duration === 0) {
      item.style.height = endHeight;
      onFinish();
      return;
    }

    const animation = item.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      }
    );

    animations.set(item, animation);

    animation.onfinish = () => {
      animations.delete(item);
      onFinish();
    };

    animation.oncancel = () => {
      animations.delete(item);
    };
  }

  function syncAria(item, expanded) {
    const summary = item.querySelector('summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function openItem(item, animate = true) {
    const summary = item.querySelector('summary');
    const content = summary?.nextElementSibling;
    if (!summary || !content) return;

    const startHeight = `${item.offsetHeight || summary.offsetHeight}px`;

    item.open = true;
    syncAria(item, true);

    const endHeight = `${summary.offsetHeight + content.scrollHeight}px`;

    if (!animate) {
      cancelAnimation(item);
      cleanupItemStyles(item);
      return;
    }

    animateItem(item, startHeight, endHeight, () => {
      cleanupItemStyles(item);
    });
  }

  function closeItem(item, animate = true) {
    if (!item.open) return;

    const summary = item.querySelector('summary');
    if (!summary) return;

    const startHeight = `${item.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight}px`;

    if (!animate) {
      cancelAnimation(item);
      item.open = false;
      syncAria(item, false);
      cleanupItemStyles(item);
      return;
    }

    animateItem(item, startHeight, endHeight, () => {
      item.open = false;
      syncAria(item, false);
      cleanupItemStyles(item);
    });
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-product-collapsible-item] > summary');
    if (!summary) return;

    const item = summary.parentElement;
    if (!item || !item.closest('.product__accordion')) return;

    event.preventDefault();

    if (item.open) {
      closeItem(item, true);
      return;
    }

    openItem(item, true);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const selectedBlock = event.target.closest('.product__accordion');
    if (!selectedBlock) return;

    const item = selectedBlock.querySelector('[data-product-collapsible-item]');
    if (!item) return;

    openItem(item, true);

    const summary = item.querySelector('summary');
    if (summary) summary.focus();
  });
})();
